import { render } from "./areaTeaWorkAgeEchart.vue?vue&type=template&id=76677d88&scoped=true"
import script from "./areaTeaWorkAgeEchart.vue?vue&type=script&lang=js"
export * from "./areaTeaWorkAgeEchart.vue?vue&type=script&lang=js"

import "./areaTeaWorkAgeEchart.vue?vue&type=style&index=0&id=76677d88&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76677d88"]])

export default __exports__